import React, { FC, Suspense, useEffect, useRef } from 'react';
import Loader from 'src/components/widgets/loader';
import OverlayLoading from 'src/components/widgets/overlayLoading';
import { Load3DSceneEditor } from 'src/components/widgets/preview3D';
import usePreview3DStore from 'src/components/widgets/preview3D/store';
import styled from 'styled-components';

const ComposerPreviewContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
    flex-grow: 1;
    height: 100%;
`;

const ComposerPreview: FC<{}> = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [sceneEditor, sceneManager, designManager, zkProduct] = usePreview3DStore((x) => [x.sceneEditor, x.sceneManager, x.designManager, x.zkProduct]);
    const variantId = zkProduct?.get('colors').at(0).get('colorID');
    const updateColor = async () => {
        // We can't use the classic selectAttribteValue in ComposerSelection because it requires a fully constructed
        // composer selection with all attributes and options, but the variant attribute could be created on the fly
        const attributeSelection = sceneManager!.getSelectedAttributeOption(zkProduct!.get('colors').find((x) => x.get('colorID') === variantId)!);

        if (attributeSelection && attributeSelection.attributeGuid && attributeSelection.optionGuid) {
            const zkAttribute = zkProduct!.get('attributes').find((x) => x.get('attributeGuid') == attributeSelection.attributeGuid);

            if (zkAttribute) {
                const zkOption = zkAttribute.get('options').find((x) => x.get('optionGuid') == attributeSelection.optionGuid);

                if (zkOption) {
                    const actions = zkOption.get('actions').sortBy(function (item) {
                        return item.get('execOrder');
                    });

                    await sceneEditor!.executeActionsAsync(null, null, actions);
                    sceneEditor!.adjustCamera(false);
                } else throw `Option ${attributeSelection.optionGuid} not found`;
            } else throw `Attribute ${attributeSelection.attributeGuid} not found`;
        }

        setTimeout(() => designManager?.refreshSides(variantId!), 50);
    };

    useEffect(() => {
        if (containerRef.current && sceneEditor) {
            sceneEditor.appendTo(containerRef.current);
            sceneEditor.updateView(true, true);
            if (variantId) {
                updateColor().catch((error) => console.error('Error updating color:', error));
            }
        }
        console.log('ComposerPreview mounted', sceneEditor);
    }, [containerRef.current, sceneEditor]);

    return (
        <Suspense fallback={<Loader />}>
            <Load3DSceneEditor onProgress={() => null} fallback={<OverlayLoading forceShow />} damMode={false} isConfiguratorProduct={true} notLoadDesign={true}>
                <ComposerPreviewContainer ref={containerRef}>
                    <Loader />
                </ComposerPreviewContainer>
            </Load3DSceneEditor>
        </Suspense>
    );
};

export default ComposerPreview;
